import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function LoginForm() {
    const [loginIdentifier, setLoginIdentifier] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();
    const { login } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');

        try {
            const loggedInUser = await login(loginIdentifier, password);

            // --- THIS IS THE CORRECTED PART ---
            // The URL was incorrect and has been fixed.
            if (loggedInUser.role === 'admin' || loggedInUser.role === 'superadmin') {
                navigate('/portal-management-7a8b9c');
            } else {
                navigate('/my-dashboard');
            }
        } catch (error) {
            setMessage(error.message || 'Login failed.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="glass p-8 md:p-10 rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] w-full max-w-md relative">
            <h2 className="text-4xl font-extrabold text-brand-secondary text-center mb-8 tracking-tight">Member Login</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
                <input
                    type="text"
                    value={loginIdentifier}
                    onChange={(e) => setLoginIdentifier(e.target.value)}
                    placeholder="Email or Phone Number"
                    required
                    className="w-full p-4 bg-white/60 text-brand-secondary rounded-2xl border border-white/40 focus:outline-none focus:ring-2 focus:ring-brand-primary placeholder-slate-400 font-medium transition-shadow focus:bg-white"
                />
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Password"
                    required
                    className="w-full p-4 bg-white/60 text-brand-secondary rounded-2xl border border-white/40 focus:outline-none focus:ring-2 focus:ring-brand-primary placeholder-slate-400 font-medium transition-shadow focus:bg-white"
                />
                <button type="submit" disabled={isLoading} className="w-full p-4 mt-2 bg-brand-primary hover:bg-emerald-700 rounded-full font-bold text-white transition-all transform hover:-translate-y-1 shadow-lg shadow-emerald-700/30 disabled:bg-slate-300 disabled:transform-none disabled:shadow-none text-lg">
                    {isLoading ? 'Logging In...' : 'Login'}
                </button>
                {message && <p className="text-red-500 text-center mt-4 font-medium px-4 py-2 bg-red-50 rounded-xl border border-red-100">{message}</p>}

                <div className="mt-6 text-center text-brand-secondary font-medium flex flex-col gap-2">
                    <div>
                        New to Health Card? <span onClick={() => navigate('/register')} className="text-brand-primary cursor-pointer hover:underline font-bold">Register here</span>
                    </div>
                    <div>
                        <span onClick={() => navigate('/forgot-password')} className="text-brand-primary cursor-pointer hover:underline font-bold">Forgot Password?</span>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default LoginForm;

